export enum FixedColumnPosition {
    FIRST = 1,
    LAST,
}
